/**
 * @generated SignedSource<<be6ae44fd11772903154fa2ff10aa6ce>>
 * @relayHash f6deebf30059f6281cb9bf02e6322b7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type JiraVersionSortField = "DESCRIPTION" | "NAME" | "RELEASE_DATE" | "SEQUENCE" | "START_DATE" | "%future added value";
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraVersionSortInput = {
  order: SortDirection;
  sortByField: JiraVersionSortField;
};
export type uiProjectVersionsQuery$variables = {
  cloudId: string;
  filter: ReadonlyArray<JiraVersionStatus | null | undefined>;
  initialLoadCount: number;
  isManageVersionsPermissionEnabled: boolean;
  projectKey: string;
  searchString: string;
  sortBy: JiraVersionSortInput;
};
export type uiProjectVersionsQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly canEditVersions?: {
        readonly canPerform: boolean;
      } | null | undefined;
      readonly jiraProjectType: JiraProjectType | null | undefined;
      readonly key: string;
      readonly name: string;
      readonly projectId: string;
      readonly versions: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly __typename: "JiraVersionEdge";
        } | null | undefined> | null | undefined;
        readonly errors: ReadonlyArray<{
          readonly extensions: ReadonlyArray<{
            readonly statusCode: number | null | undefined;
          }> | null | undefined;
        }> | null | undefined;
      };
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"table_projectVersions">;
};
export type uiProjectVersionsQuery = {
  response: uiProjectVersionsQuery$data;
  variables: uiProjectVersionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "initialLoadCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isManageVersionsPermissionEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "key"
},
v11 = {
  "alias": "jiraProjectType",
  "kind": "ScalarField",
  "name": "projectType"
},
v12 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "MANAGE_VERSIONS"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "canPerform"
},
v14 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v15 = {
  "kind": "Variable",
  "name": "searchString",
  "variableName": "searchString"
},
v16 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v19 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v20 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v21 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v22 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "initialLoadCount"
},
v23 = [
  (v14/*: any*/),
  (v22/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "id"
},
v25 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v26 = [
  (v25/*: any*/)
],
v27 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": "DONE"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiProjectVersionsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v7/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v8/*: any*/),
                    "action": "THROW",
                    "path": "jira.jiraProjectByKey.projectId"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v9/*: any*/),
                    "action": "THROW",
                    "path": "jira.jiraProjectByKey.name"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v10/*: any*/),
                    "action": "THROW",
                    "path": "jira.jiraProjectByKey.key"
                  },
                  (v11/*: any*/),
                  {
                    "condition": "isManageVersionsPermissionEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "canEditVersions",
                        "args": (v12/*: any*/),
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v13/*: any*/),
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey.canEditVersions.canPerform"
                          }
                        ],
                        "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                      }
                    ]
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "versions",
                      "args": [
                        (v14/*: any*/),
                        (v15/*: any*/),
                        (v16/*: any*/)
                      ],
                      "concreteType": "JiraVersionConnection",
                      "kind": "LinkedField",
                      "name": "__uiProject__versions_connection",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraVersionEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            (v17/*: any*/),
                            (v18/*: any*/),
                            {
                              "concreteType": "JiraVersion",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v17/*: any*/)
                              ]
                            }
                          ]
                        },
                        {
                          "concreteType": "QueryError",
                          "kind": "LinkedField",
                          "name": "errors",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "extensions",
                              "plural": true,
                              "selections": [
                                (v19/*: any*/)
                              ]
                            }
                          ]
                        },
                        (v20/*: any*/),
                        (v21/*: any*/)
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.jiraProjectByKey.versions"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "args": [
          (v14/*: any*/),
          (v22/*: any*/),
          {
            "kind": "Variable",
            "name": "isManageVersionsPermissionEnabled",
            "variableName": "isManageVersionsPermissionEnabled"
          },
          (v15/*: any*/),
          (v16/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "table_projectVersions"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiProjectVersionsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "condition": "isManageVersionsPermissionEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "canEditVersions",
                    "args": (v12/*: any*/),
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/)
                    ],
                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                  }
                ]
              },
              {
                "args": (v23/*: any*/),
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v24/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "startDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "releaseDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "overdue"
                          },
                          {
                            "alias": "allIssues",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "ALL"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"ALL\")"
                          },
                          {
                            "alias": "doneIssues",
                            "args": (v27/*: any*/),
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"DONE\")"
                          },
                          {
                            "alias": "done",
                            "args": (v27/*: any*/),
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"DONE\")"
                          },
                          {
                            "alias": "inProgress",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "IN_PROGRESS"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                          },
                          {
                            "alias": "toDo",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "TODO"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"TODO\")"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "versionId"
                          },
                          (v9/*: any*/),
                          (v21/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v19/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v25/*: any*/)
                ]
              },
              {
                "args": (v23/*: any*/),
                "filters": [
                  "filter",
                  "searchString",
                  "sortBy"
                ],
                "handle": "connection",
                "key": "uiProject__versions",
                "kind": "LinkedHandle",
                "name": "versions"
              },
              (v24/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectType"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395",
    "metadata": {
      "connection": [
        {
          "count": "initialLoadCount",
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "jiraProjectByKey",
            "versions"
          ]
        }
      ]
    },
    "name": "uiProjectVersionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d200347d20dfa0c568d719d21b96cc62";

export default node;
